import React, { FC } from 'react';
import { Button, makeStyles } from '@material-ui/core';
import { DialogType } from 'src/redux/types/redux.types';
import { i18nService } from 'services/i18n.service';
import cx from 'classnames';
import { Spinner } from 'reactstrap';

interface ActionsProps {
  type: DialogType;
  data?: any;
  onClose?: React.MouseEventHandler<any>;
  onConfirm?: React.MouseEventHandler<any>;
  isDisabled?: boolean;
  processing?: boolean;
  customLabels?: {
    cancel?: string;
    confirm?: string;
  };
}

const useStyles = makeStyles(() => {
  return {
    root: {
      minWidth: 130,
      height: 50,
      fontSize: 18,
      borderRadius: '10px',
      textTransform: 'capitalize',
    },
    containedPrimary: {
      backgroundColor: '#2164a3',
      color: 'white',
    },
    leftBtn: {
      marginRight: 20,
    },
    btnsContainer: {
      width: '100%',
      padding: '0px 23px 10px',
      display: 'flex',
      justifyContent: 'flex-end',
    },
    alertBtn: {
      backgroundColor: '#2164a3',
      color: 'white',
    },
    loader: {
      width: '1rem',
      height: '1rem',
      marginRight: '0.5rem',
      color: 'gray',
    },
    disabled: {
      color: 'gray !important',
    },
  };
});
const Actions: FC<ActionsProps> = ({
  type,
  data,
  onClose,
  onConfirm,
  isDisabled = false,
  processing = false,
  customLabels = {},
}) => {
  const classes = useStyles();
  switch (type) {
    case DialogType.DeleteConfirm:
      return (
        <div className={classes.btnsContainer}>
          <Button
            variant="outlined"
            color="inherit"
            className={cx(classes.root, classes.leftBtn)}
            aria-label="cancel"
            onClick={onClose}
          >
            {customLabels?.cancel ? customLabels.cancel : i18nService.translate('cancel')}
          </Button>
          <Button
            variant="contained"
            className={cx(classes.root, classes.containedPrimary)}
            aria-label="delete"
            onClick={onConfirm}
            disabled={isDisabled}
          >
            {processing ? (
              <Spinner color="primary" className={cx(classes.loader, classes.disabled)} />
            ) : null}
            {customLabels?.confirm
              ? customLabels.confirm
              : i18nService.translate('modal.delete.deleteButton', {
                  data,
                })}
          </Button>
        </div>
      );
    case DialogType.Confirm:
      return (
        <div className={classes.btnsContainer}>
          <Button
            variant="outlined"
            color="inherit"
            aria-label="cancel"
            className={cx(classes.root, classes.leftBtn)}
            onClick={onClose}
          >
            {customLabels?.cancel ? customLabels.cancel : i18nService.translate('no')}
          </Button>
          <Button
            variant="contained"
            className={cx(classes.root, classes.containedPrimary)}
            onClick={onConfirm}
            disabled={isDisabled}
          >
            {processing ? (
              <Spinner color="primary" className={cx(classes.loader, classes.disabled)} />
            ) : null}
            {customLabels?.confirm ? customLabels.confirm : i18nService.translate('yes')}
          </Button>
        </div>
      );
    case DialogType.Notification:
      return (
        <div className={classes.btnsContainer}>
          <Button
            variant="contained"
            className={cx(classes.root, classes.containedPrimary)}
            onClick={onClose}
            disabled={isDisabled}
          >
            {processing ? (
              <Spinner color="primary" className={cx(classes.loader, classes.disabled)} />
            ) : null}
            {customLabels?.confirm ? customLabels.confirm : i18nService.translate('Okay')}
          </Button>
        </div>
      );
    case DialogType.Alert:
      return (
        <div className={classes.btnsContainer}>
          <Button
            variant="contained"
            className={cx(classes.root, classes.containedPrimary, classes.alertBtn)}
            onClick={onClose}
          >
            {customLabels?.confirm ? customLabels.confirm : i18nService.translate('buttons.ok')}
          </Button>
        </div>
      );
    default:
      return null;
  }
};

export default Actions;
